import { getRadioUtilityClass, radioClasses as muiRadioClasses } from '@mui/material';

export const Sizes = {
  medium: {
    icon: 20,
    dot: 12,
  },
  small: {
    icon: 16,
    dot: 8,
  },
};

export const radioClasses = {
  ...muiRadioClasses,
  small: getRadioUtilityClass('small'),
  medium: getRadioUtilityClass('medium'),
  iconContainer: getRadioUtilityClass('iconContainer'),
  dot: getRadioUtilityClass('dot'),
};
